var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_vm._m(0),_c('div',{staticClass:"container d-flex justify-content-center"},[_c('LoginForm')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"container d-flex justify-content-center"})])
}]

export { render, staticRenderFns }